import { Icon } from "@mui/material";
import { UserContext } from "App";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import { useContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Swal from "sweetalert2";
import AppointmentsApi from "../../../../Classes/API/Appointments/AppointmentsApi";
import LinkAccSessToAppHourReq from "../../../../Classes/Models/Requests/Appointments/LinkAccSessToAppHourReq";
import SearchStringOrIntReq from "../../../../Classes/Models/Requests/SearchStringOrIntReq";
import AddFacilityModal from "./AddFacilityModal";
import AppHourCell2 from "./AppHourCell2";
import CreateAppointmentPopUp from "./CreateAppointmentPopUp";
import Loader from "layouts/loader/loader";
import AddTherapistToDay from "../../AppointmentDays/AppointmentDayDetails/AddTherapistToDay";
import CopyDayCard from "./CopyDayCard";
import MDInput from "components/MDInput";
import { LanguageContext } from "App";
import AsyncSelect from "react-select/async";
import MDButton from "components/MDButton";
import UsersApi from "../../../../Classes/API/UsersApi";
import searchUsersReq from "../../../../Classes/Models/Requests/Users/SearchUser";
import SearchUserModel from "../../../../Classes/Models/Requests/Users/SearchUser";
import PatientSuggestions from "./PatientSuggestions";

import "./AppDay.scss";
import { Add, AddCircle, RemoveCircle, ZoomIn, ZoomOut } from "@mui/icons-material";
import translations from "layouts/Appointments/Feedback/translations";
const AppDayTableSimple = ({
  AppDay,
  setAppDay,
  setIsLoaded,
  GetAppDayById,
  IsLoaded,
  setShowCopyDay,
  ShowCopyDay,
  setShowAddTherapist,
  ShowAddTherapist,
  checkedDays,
  DayPartitionNumber,
  setDayPartitionNumber,
  id,
}) => {
  let { state } = useLocation();
  const CurrentUser = useContext(UserContext);
  // const [DayPartitionNumber, setDayPartitionNumber] = useState(2);
  const [DayPartitionNumberRetrievedBefore1, setDayPartitionNumberRetrievedBefore1] =
    useState(false);
  const [DayPartitionNumberRetrievedBefore2, setDayPartitionNumberRetrievedBefore2] =
    useState(false);
  const [DayPartitionNumberRetrievedBefore3, setDayPartitionNumberRetrievedBefore3] =
    useState(false);
  const [ShowCreateAppointment, setShowCreateAppointment] = useState(false);
  const [SelectedAppHour, setSelectedAppHour] = useState({});
  const [FacilityAccSession, setFacilityAccSession] = useState({});
  const [ShowFacilityModal, setShowFacilityModal] = useState(false);
  const [ShowSideBar, setShowSideBar] = useState(false);
  const [MovingSession, _setMovingSession] = useState({});
  const [Reminders, setReminders] = useState([]);
  const [isInnerLoaded, setIsInnerLoaded] = useState(true);
  const { translations, switchLanguage } = useContext(LanguageContext);
  const [SearchString, setSearchString] = useState("");
  const [PatientsSearch, setPatientsSearch] = useState("");
  const [Patient, setPatient] = useState(null);
  const [TherapistSearch, setTherapistSearch] = useState("");
  const [Therapist, setTherapist] = useState(null);
  const [zoomLevel, setZoomLevel] = useState(0.7);
  const [Height, setHeight] = useState(100);
  const [isCollapsed, setIsCollapsed] = useState(false);

  const toggleHeader = () => {
    setIsCollapsed(!isCollapsed);
  };

  const handleZoomIn = () => {
    setZoomLevel((prevZoom) => Math.min(prevZoom + 0.05, 0.9)); // Maximum zoom level of 2
  };

  const handleZoomOut = () => {
    setZoomLevel((prevZoom) => Math.max(prevZoom - 0.05, 0.2)); // Minimum zoom level of 0.5
  };

  const handleHeightZoomIn = () => {
    setHeight((prevheight) => Math.min(prevheight + 15, 420)); // Maximum zoom level of 2
  };

  const handleHeightZoomOut = () => {
    setHeight((prevheight) => Math.max(prevheight - 15, 30)); // Minimum zoom level of 0.5
  };

  useEffect(() => {
    if (AppDay.id != null) {
      GetDayReminders();
    }
  }, [AppDay]);

  useEffect(() => {
    if (DayPartitionNumber == 1) {
      setDayPartitionNumberRetrievedBefore1(true);
      setDayPartitionNumberRetrievedBefore2(false);
      setDayPartitionNumberRetrievedBefore3(false);
      GetAppDayById(AppDay.id, DayPartitionNumber);
      setIsInnerLoaded(false);
    }
    if (DayPartitionNumber == 2) {
      setDayPartitionNumberRetrievedBefore2(true);
      setDayPartitionNumberRetrievedBefore1(false);
      setDayPartitionNumberRetrievedBefore3(false);
      GetAppDayById(AppDay.id, DayPartitionNumber);
      setIsInnerLoaded(false);
    }
    if (DayPartitionNumber == 3) {
      setDayPartitionNumberRetrievedBefore3(true);
      setDayPartitionNumberRetrievedBefore1(false);
      setDayPartitionNumberRetrievedBefore2(false);
      GetAppDayById(AppDay.id, DayPartitionNumber);
      setIsInnerLoaded(false);
    }
  }, [DayPartitionNumber]);

  useEffect(() => {
    if (AppDay != null) {
      setIsInnerLoaded(true);
    }
  }, [AppDay]);

  const onSearch = async () => {
    Swal.fire({
      title: "Please wait",
      text: "Loading...",
      showConfirmButton: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });
    console.log(AppDay);
    const searchString = SearchString.trim().toLowerCase();

    if (searchString === "") {
      console.log(id, DayPartitionNumber);
      await GetAppDayById(id, DayPartitionNumber);
      return;
    }

    const filteredTherapists = AppDay.getTherapists
      .map((therapist) => {
        const filteredHours = therapist.getAppointmentHours
          .map((hour) => {
            const filteredSessions = hour.getListedAccountingSessions.filter(
              (session) =>
                session.therapistName.toLowerCase().includes(searchString) ||
                session.sessionName.toLowerCase().includes(searchString) ||
                session.patientName.toLowerCase().includes(searchString)
            );

            return {
              ...hour,
              getListedAccountingSessions: filteredSessions,
            };
          })
          .filter((hour) => hour.getListedAccountingSessions.length > 0);

        return {
          ...therapist,
          getAppointmentHours: filteredHours,
        };
      })
      .filter((therapist) => therapist.getAppointmentHours.length > 0);

    const filteredAppDay = {
      ...AppDay,
      getTherapists: filteredTherapists,
    };

    setAppDay(filteredAppDay);
    Swal.hideLoading();
    Swal.close();
  };

  const GetDayReminders = async () => {
    let req = new SearchStringOrIntReq();
    req.SearchInt = AppDay.id;
    let res = await AppointmentsApi.GetDayReminders(req);
    console.log(res);
    if (res.status == "Success") {
      setReminders(res.data);
    }
  };

  const setMovingSession = (accSession) => {
    _setMovingSession(accSession);
    // swal notification top right
    Swal.fire({
      position: "top-end",
      icon: "info",
      text: "Session Id: " + accSession.id + " is selected to move",
      showConfirmButton: false,
      timer: 1200,
    });
  };

  const PasteSession = async (appHour) => {
    if (MovingSession.id == null) {
      return;
    }
    Swal.fire({
      icon: "info",
      title: "Moving Session...",
      text: "This may take a few minutes...",
      didOpen: () => {
        Swal.showLoading();
      },
      toast: true,
      position: "top-end",
      showConfirmButton: false,
      timer: 1200,
    });

    let req = new LinkAccSessToAppHourReq(MovingSession.id, appHour.id, false, false);
    let res = await AppointmentsApi.LinkAccountingSessionToAppointmentHour(req);
    if (res.status == "Success") {
      Swal.fire({
        title: "Success",
        text: "Re-fething data...",
        didOpen: () => {
          Swal.showLoading();
        },
        icon: "success",
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 1200,
      });
      _setMovingSession({});
      let res2 = await GetAppDayById(AppDay.id, DayPartitionNumber);
      if (res2.status == "Success") {
        Swal.fire({
          title: "Success",
          text: res.message,
          icon: "success",
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 1200,
        });
      } else {
        Swal.fire({
          title: "Failed",
          text: res.message,
          icon: "error",
        });
      }
    } else {
      Swal.fire({
        title: "Error",
        text: res.message,
        icon: "error",
      });
    }
  };

  useEffect(() => {
    let sideNav = document.getElementById("TheSidenav");
    if (ShowSideBar) {
      sideNav.style.display = "block";
    } else {
      sideNav.style.display = "none";
    }
    return () => {
      sideNav.style.display = "block";
    };
  }, [ShowSideBar]);

  const checkDays = async () => {
    let checkedDaysText = "";

    // Loop over checkedDays and build the text
    checkedDays.forEach((day, index) => {
      checkedDaysText += `<div style="text-align: left;"> Session ${
        index + 1
      }: <br> ${day}</div><br><br>`; // Use HTML line breaks
    });

    // Display the SweetAlert with the checkedDays information
    Swal.fire({
      icon: "info",
      title: "Checked Days Preview",
      html: checkedDaysText, // Set HTML property instead of text
      allowOutsideClick: false,
    });
  };
  const ClearAppointmentDay = async () => {
    let confirmation = await Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, clear it!",
    });

    if (!confirmation.isConfirmed) {
      return;
    }

    Swal.fire({
      icon: "info",
      title: "Clearing Appointments...",
      text: "This may take a few minutes...",
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    let req = new SearchStringOrIntReq();
    req.SearchInt = AppDay.id;

    let res = await AppointmentsApi.ClearAppointmentDay(req);
    console.log(res);

    if (res.status == "Success") {
      Swal.fire("Success", res.message, "success");
      setIsLoaded(false);
    } else {
      Swal.fire("Failed", res.message, "error");
    }
  };
  const GetDayPartitionButtons = () => {
    return (
      <div className="time-session-btn">
        <button
          className={
            DayPartitionNumber === 1 ? "btn btn-sm btn-success" : "btn btn-sm btn-outline-secondary"
          }
          onClick={() => {
            setDayPartitionNumber(1);
          }}
        >
          00:00 - 07:00
        </button>
        <button
          className={
            DayPartitionNumber === 2 ? "btn btn-sm btn-success" : "btn btn-sm btn-outline-secondary"
          }
          onClick={() => {
            setDayPartitionNumber(2);
          }}
        >
          08:00 - 15:00
        </button>
        <button
          className={
            DayPartitionNumber === 3 ? "btn btn-sm btn-success" : "btn btn-sm btn-outline-secondary"
          }
          onClick={() => {
            setDayPartitionNumber(3);
          }}
        >
          16:00 - 23:00
        </button>
      </div>
    );
  };
  const MakeHeaderRow = () => {
    // modify the day to be in the format of the daypartition
    console.log("HEADER_ROW DayPartitionNumber: " + DayPartitionNumber);
    var headerArr = [];
    for (let i = 0; i < DayPartitionNumber * 8; i++) {
      if (i >= (DayPartitionNumber - 1) * 8) {
        headerArr.push(<th>{i < 10 ? "0" + i + ":00" : i + ":00"}</th>);
      }
    }

    return headerArr;
  };
  const MakeTableRow = (tDay) => {
    if (CurrentUser.userType === "Therapist" && tDay.therapistId !== CurrentUser.getTherapist?.id) {
      return null;
    }
    return (
      <tr>
        {/* Sticky first column */}
        <td
          className="sticky-col sticky-col-1"
          style={{ backgroundColor: "#242424", color: "#fff" }}
        >
          {tDay.therapistName}
        </td>

        {/* Regular columns */}
        {tDay.getAppointmentHours
          .sort((a, b) => (a.hour > b.hour ? 1 : -1))
          .map((appHour) => {
            if (
              appHour.hourIndex < DayPartitionNumber * 8 &&
              appHour.hourIndex >= (DayPartitionNumber - 1) * 8
            ) {
              return (
                <td key={appHour.id}>
                  <AppHourCell2
                    AppDay={AppDay}
                    AppHour={appHour}
                    setSelectedAppHour={setSelectedAppHour}
                    EnableFacilityModal={EnableFacilityModal}
                    EnableAppointmentModal={EnableAppointmentModal}
                    PasteSession={PasteSession}
                    setMovingSession={setMovingSession}
                    setIsLoaded={setIsLoaded}
                    Reminders={Reminders}
                    LoadReminders={GetDayReminders}
                  />
                </td>
              );
            }
            return null;
          })}
      </tr>
    );
  };

  const EnableFacilityModal = (enable, accSession) => {
    if (!enable) {
      setShowFacilityModal(false);
      return;
    }
    setFacilityAccSession(accSession);
    setShowFacilityModal(true);
  };
  const EnableAppointmentModal = (enable, appHour) => {
    if (!enable) {
      setShowCreateAppointment(false);
      return;
    }
    setSelectedAppHour(appHour);
    setShowCreateAppointment(true);
  };
  console.log({ AppDay });

  const AddSessionToAppointmentHour = (session, appHour) => {
    console.log({ session, appHour, AppDay, setAppDay });

    setAppDay((prevAppDay) => {
      console.log({ prevAppDay });

      return {
        ...prevAppDay,
        getTherapists: prevAppDay.getTherapists.map((th) => {
          console.log(th.id, appHour.therapistId);
          return th.id === appHour.appointmentDayTherapistId
            ? {
                ...th,
                getAppointmentHours: th.getAppointmentHours.map((aH) =>
                  aH.id === appHour.id
                    ? {
                        ...aH,
                        getListedAccountingSessions: [
                          ...(aH.getListedAccountingSessions ?? []),
                          session,
                        ],
                      }
                    : aH
                ),
              }
            : th;
        }),
      };
    });
  };

  return (
    <div className="app-day appDayTableCard">
      <MDBox style={{ marginLeft: ShowSideBar ? "250px" : "0px" }}>
        <div className={`header-element ${isCollapsed ? "collapsed" : ""}`}>
          <div>
            <MDTypography mb={3} variant="h5">
              <button
                className="btn btn-sm btn-dark"
                onClick={() => {
                  setShowSideBar(!ShowSideBar);
                }}
              >
                {ShowSideBar ? <Icon>close</Icon> : <Icon>menu</Icon>}
              </button>
              <div className="Day-date-card">
                <span>
                  Day: {new Date(AppDay.dateDay).toLocaleDateString("en-GB").split(",")[0]}
                </span>
                - <p>ID: {AppDay.id}</p>
              </div>
              <div className="function-btn">
                {(CurrentUser.userType == "Admin" ||
                  CurrentUser.userType == "AppointmentEmployee") && (
                  <button
                    className="btn btn-sm btn-outline-dark ml-4"
                    onClick={() => {
                      setShowAddTherapist(!ShowAddTherapist);
                    }}
                  >
                    {ShowAddTherapist
                      ? translations.appointmentTableCancelTherapist
                      : translations.appointmentTableAddTherapist}
                  </button>
                )}

                {(CurrentUser.userType == "Admin" ||
                  CurrentUser.userType == "AppointmentEmployee") && (
                  <button
                    className="btn btn-sm btn-outline-dark ml-4"
                    onClick={() => {
                      setShowCopyDay(!ShowCopyDay);
                    }}
                  >
                    {ShowCopyDay
                      ? translations.appointmentTableCancelCopy
                      : translations.appointmentTableSmartCopyAnotherDay}
                  </button>
                )}

                {(CurrentUser.userType == "Admin" ||
                  CurrentUser.userType == "AppointmentEmployee") && (
                  <button
                    className="btn btn-sm btn-outline-danger ml-4"
                    onClick={ClearAppointmentDay}
                  >
                    {translations.appointmentTableClearAllSessions}
                  </button>
                )}
              </div>
              {(CurrentUser.userType == "Admin" ||
                CurrentUser.userType == "AppointmentEmployee") && (
                <div className="session-name-input">
                  <div className="appointment-input">
                    <MDInput
                      className={translations.setlang === "ar" ? "rtl-label" : ""}
                      onChange={(e) => setSearchString(e.target.value)}
                      label={translations.appointmentTablesearchappointments}
                    />
                  </div>
                  <div>
                    <MDButton
                      onClick={onSearch}
                      sx={{ backgroundColor: "#3560AD", "&:hover": { backgroundColor: "#4682B4" } }}
                      color="info"
                    >
                      <Icon sx={{ fontWeight: "bold" }}>search</Icon>&nbsp;
                    </MDButton>
                  </div>
                </div>
              )}
            </MDTypography>
          </div>

          <MDBox mt={-2}>{GetDayPartitionButtons()}</MDBox>

          <MDBox>
            <div className="zoom-controls">
              <button onClick={handleHeightZoomOut} variant="gradient" color="info">
                <RemoveCircle sx={{ width: "25px", height: "25px" }} />
              </button>
              <button
                onClick={handleHeightZoomIn}
                variant="gradient"
                color="info"
                sx={{ marginLeft: "8px" }}
              >
                <AddCircle sx={{ width: "25px", height: "25px" }} />
              </button>
            </div>
            <div className="zoom-controls">
              <button onClick={handleZoomOut} variant="gradient" color="info">
                <ZoomOut sx={{ width: "25px", height: "25px" }} />
              </button>
              <button
                onClick={handleZoomIn}
                variant="gradient"
                color="info"
                sx={{ marginLeft: "8px" }}
              >
                <ZoomIn sx={{ width: "25px", height: "25px" }} />
              </button>
            </div>
          </MDBox>
          {/* Collapsible button */}
          <button className="collapse-btn" onClick={toggleHeader}>
            {isCollapsed ? <Icon>expand_more</Icon> : <Icon>expand_less</Icon>}
          </button>
        </div>

        {ShowCopyDay && (
          <MDBox mt={3}>
            <CopyDayCard CurrentDay={AppDay} setAppDay={setAppDay} />
          </MDBox>
        )}
        {ShowAddTherapist && <AddTherapistToDay AppDay={AppDay} setIsLoaded={setIsLoaded} />}
      </MDBox>

      {isInnerLoaded ? (
        <div className="table-container" style={{ marginLeft: ShowSideBar ? "250px" : "0px" }}>
          <table
            className="table table-bordered mt-4 fixed-table"
            style={{ zoom: `${zoomLevel}`, transformOrigin: "top left" }}
          >
            <thead>
              <tr className="small-width text-center">
                <th className="small-width custom-font">Name / Time</th>
                {MakeHeaderRow().map((r) => {
                  return r;
                })}
              </tr>
            </thead>
            <tbody className="small-width text-center font-weight-bold">
              {AppDay.getTherapists.map((tDay) => {
                return MakeTableRow(tDay);
              })}
            </tbody>
          </table>
        </div>
      ) : (
        <Loader />
      )}
      <AddFacilityModal
        setIsLoaded={setIsLoaded}
        ShowModal={ShowFacilityModal}
        AccSession={FacilityAccSession}
        EnableModal={EnableFacilityModal}
      />
      <CreateAppointmentPopUp
        AppDay={AppDay}
        setAppDay={setAppDay}
        GetAppDayById={GetAppDayById}
        AppHour={SelectedAppHour}
        ShowCreateAppointment={ShowCreateAppointment}
        EnableModal={EnableAppointmentModal}
        DayPartitionNumber={DayPartitionNumber}
        AddSession={AddSessionToAppointmentHour}
      />
      <div className="patient-suggestion" style={{ marginLeft: ShowSideBar ? "250px" : "0px" }}>
        <PatientSuggestions />
      </div>
    </div>
  );
};
export default AppDayTableSimple;
